import { render, staticRenderFns } from "./FdTextArea.vue?vue&type=template&id=34a6d38b&scoped=true"
import script from "./FdTextArea.vue?vue&type=script&lang=js"
export * from "./FdTextArea.vue?vue&type=script&lang=js"
import style0 from "./FdTextArea.vue?vue&type=style&index=0&id=34a6d38b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a6d38b",
  null
  
)

export default component.exports